import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authErrorEvent } from '../services/api/apiClient';

/**
 * Hook to handle authentication errors globally
 * Listens for authError events from apiClient and redirects to login
 */
export function useAuthErrorHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthError = (event: Event) => {
      const customEvent = event as CustomEvent;
      const { statusCode, message } = customEvent.detail;

      console.warn(`Auth Error [${statusCode}]: ${message}`);

      // Redirect to admin login page
      navigate('/admin/login', {
        replace: true,
        state: { reason: 'Token expired. Please login again.' },
      });
    };

    // Listen for auth error events
    authErrorEvent.addEventListener('authError', handleAuthError);

    // Cleanup on unmount
    return () => {
      authErrorEvent.removeEventListener('authError', handleAuthError);
    };
  }, [navigate]);
}

export default useAuthErrorHandler;
